export const LOCAL = "local";
export const ADMIN = "admin";
export const USER = "user";
export const DRAWER_WIDTH = 240;
export const PRODUCTION = "production";
export const TRANSPARENCY = 0.8;
export const state = PRODUCTION;
export const APP_ID =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYiI6ImltdGV4MjAyN19pbXRtYSIsIm5hbWUiOiJJTVRFWCAyMDI3Iiwicm9sZSI6InJlZ2lzdHJhdGlvbiIsInRlbXBsYXRlIjoidGVtcGxhdGUxIiwiaWF0IjoxNzkwMzI1MDQzLCJleHAiOjE4MjE4ODI2NDN9.R90Hhxfhgs_lFUCYvC4Yi-FvdwcWREn68psFHltIHDg";

export const TD_ID =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYiI6ImltdGV4MjAyN19pbXRtYSIsIm5hbWUiOiJJTVRFWCAyMDI3Iiwicm9sZSI6InJlZ2lzdHJhdGlvbiIsInRlbXBsYXRlIjoidGQiLCJpYXQiOjE3OTAzMjUwNDMsImV4cCI6MTgyMTg4MjY0M30.lW-hRQB3MKuMuj-WxqaUGl5VxZOrBfQQXStrFFmbOrI";
export const API_ENDPOINT =
  state === PRODUCTION
    ? "https://apis.expoplanner.in"
    : "http://localhost:5002";

export const TimeZoneIndia = {
  timeZone: "Asia/Kolkata", // IST Timezone
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};
export const TimeOnlyZone = {
  timeZone: "Asia/Kolkata",
  hour: "2-digit",
  minute: "2-digit",
};
